import React, { useState } from 'react';
import Footer from 'shared/components/footer/Footer';
import 'shared/styles/payment.css';
import {
  Alert,
  ButtonLink,
  FunnelPage,
  FunnelSection,
  SectionHeader,
  StepList,
} from 'shared/components/funnel/FunnelUI';

const paymentInfo = {
  USDT: {
    address: 'TEPJARNvzP9yCWfDhpkNeXm8dUaGg6P8f9',
    qrCode: '/assets/images/services/vip/USDT.JPG',
    text: 'SEND USDT ONLY',
    network: 'NETWORK: TRC20',
    price: '199 USDT',
  },
};

const redeemSteps = [
  {
    title: 'Send USDT on TRC20',
    copy: 'Use the address and QR shown on this page only.',
  },
  {
    title: 'Capture payment proof',
    copy: 'Save a screenshot with transaction details visible.',
  },
  {
    title: 'Message Telegram admin',
    copy: 'Send the screenshot to redeem indicator access manually.',
  },
];

function IndicatorPayment() {
  const [copyStatus, setCopyStatus] = useState('');
  const selected = paymentInfo.USDT;

  const handleCopyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(selected.address);
      setCopyStatus('USDT address copied.');
    } catch (error) {
      setCopyStatus('Copy failed. Select the address and copy it manually.');
    }
  };

  return (
    <FunnelPage className="payment-page indicator-payment-page">
      <FunnelSection tone="hero" className="payment-hero">
        <SectionHeader
          eyebrow="Indicator payment"
          title="AI Indicator access"
          copy="Selected product: CRYPTOXNFT AI Indicator. Amount: 199 USDT. Accepted currency/network: USDT on TRC20."
        />

        <div className="funnel-payment-panel">
          <div className="funnel-payment-header">
            <div>
              <h2>USDT payment</h2>
              <p>{selected.text} / {selected.network}</p>
            </div>
            <div className="funnel-payment-price">{selected.price}</div>
          </div>

          <div className="funnel-payment-body">
            <img src={selected.qrCode} alt="USDT payment QR code" className="funnel-payment-qr" />
            <div className="funnel-payment-controls">
              <div className="funnel-address-box">
                <span>Payment address</span>
                <code>{selected.address}</code>
              </div>
              <ButtonLink onClick={handleCopyToClipboard}>Copy Address</ButtonLink>
              <div className="funnel-copy-status" role="status" aria-live="polite">
                {copyStatus}
              </div>
              <Alert tone="warning">
                Send USDT on TRC20 only. Wrong assets or networks may not be recoverable.
              </Alert>
            </div>
          </div>
        </div>
      </FunnelSection>

      <FunnelSection tone="muted">
        <div className="payment-redeem-grid">
          <SectionHeader
            align="start"
            eyebrow="Redeem indicator"
            title="Send the payment screenshot."
            copy="Indicator access is delivered manually after admin review."
          />
          <div>
            <StepList steps={redeemSteps} />
            <div className="payment-actions">
              <ButtonLink href="https://t.me/cryptoxnftsignals">Send Screenshot</ButtonLink>
              <ButtonLink to="/services/indicator" variant="secondary">Back to Indicator</ButtonLink>
            </div>
          </div>
        </div>
      </FunnelSection>

      <Footer />
    </FunnelPage>
  );
}

export default IndicatorPayment;
